const PIXI = require('pixi.js');
const analyticsEvent = require('../../viscomjs/analytics/analyticsEvent');

{
    if (!PIXI.utils.isWebGLSupported()) {
        const elem = document.querySelector('.message-block__text');
        elem.innerHTML = 'Для получения лучшего опыта включить поддержку WebGL';
        analyticsEvent('WebGL', 'load', 'No WebGL');
    } else
        analyticsEvent('WebGL', 'load', 'WebGL');

}


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/app/WebGLMessage.js